import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AccountsOverview.css';

const AccountsOverview = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accountTypes = [
    {
      name: 'Standard Account',
      description: 'Perfect for beginners and casual traders',
      features: [
        'Minimum deposit: $200',
        'Spreads from 1.0 pips',
        'No commission',
        'Leverage up to 1:1000',
        'Free trading signals',
        '24/7 support'
      ]
    },
    {
      name: 'Raw Spread Account',
      description: 'For experienced traders seeking tight spreads',
      features: [
        'Minimum deposit: $500',
        'Raw spreads from 0.0 pips',
        'Commission: $7 per lot',
        'Leverage up to 1:500',
        'Advanced trading tools',
        'Priority support'
      ]
    },
    {
      name: 'Professional Account',
      description: 'For high-volume traders and institutions',
      features: [
        'Minimum deposit: $10,000',
        'Raw spreads from 0.0 pips',
        'Reduced commission rates',
        'Higher leverage options',
        'VIP support & account manager',
        'Custom trading solutions'
      ]
    }
  ];

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span className="back-arrow">←</span>
          <span>Back to Home</span>
        </button>

        <div className="page-header">
          <h1>Accounts Overview</h1>
          <p className="subtitle">
            Choose the perfect trading account that matches your trading style and experience level. 
            All accounts feature competitive spreads, fast execution, and access to over 2,000 instruments.
          </p>
        </div>

        <div className="account-types">
          {accountTypes.map((account, index) => (
            <div key={index} className="account-card">
              <h3>{account.name}</h3>
              <p className="account-description">{account.description}</p>
              <ul className="features">
                {account.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="checkmark">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <Link to="/register" className="cta-button">Open Account</Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccountsOverview;